document.addEventListener("DOMContentLoaded", () => {
  // Use whenDefined to ensure the predictive-search element is ready before we modify it.
  customElements.whenDefined("predictive-search").then(() => {
    const bannerSearchSections = document.querySelectorAll(
      ".video-banner-section, .replacements-section",
    );

    bannerSearchSections.forEach((section) => {
      const predictiveSearchInstance =
        section.querySelector("predictive-search");

      // Check if the instance exists and hasn't been patched already.
      if (predictiveSearchInstance && !predictiveSearchInstance.isPatched) {
        // Override the render function for this specific instance.
        predictiveSearchInstance.renderSearchResults = function (
          resultsMarkup,
        ) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(resultsMarkup, "text/html");
          let modernizedMarkup = "";
          let suggestionsCount = 0;

          // Find the specific list of query suggestions that the user wants to keep.
          const queriesList = doc.querySelector(
            "#predictive-search-results-queries-list",
          );

          if (queriesList) {
            const allItems = queriesList.querySelectorAll(
              "li.predictive-search__list-item",
            );

            // Filter the list to only include pure query suggestions and limit the count to 5.
            allItems.forEach((item) => {
              const isQuery = item.id.startsWith(
                "predictive-search-option-query-",
              );
              if (!isQuery || suggestionsCount >= 5) {
                item.remove();
              } else {
                suggestionsCount++;
              }
            });

            // Only use the list if it still has valid items after filtering.
            if (suggestionsCount > 0) {
              modernizedMarkup = queriesList.outerHTML;
            }
          }

          // Perform the rendering steps from the original function.
          this.predictiveSearchResults.innerHTML = modernizedMarkup;
          this.setAttribute("results", true);

          // Re-implement the safe parts of setLiveRegionResults() using our own count.
          this.removeAttribute("loading");
          const newStatusText = `${suggestionsCount} ${suggestionsCount === 1 ? "suggestion" : "suggestions"} found.`;
          this.setLiveRegionText(newStatusText); // This is safe to call.

          this.open();
        }.bind(predictiveSearchInstance); // Bind 'this' to the correct instance.

        // Add a flag to prevent patching the same element multiple times.
        predictiveSearchInstance.isPatched = true;
      }
    });
  });
});
